/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type { StartMyUserOnboardingMutationResponse } from "../types/StartMyUserOnboarding.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const startMyUserOnboardingMutationKey = () =>
  [{ url: "/v1/user-onboarding/me/start" }] as const

export type StartMyUserOnboardingMutationKey = ReturnType<
  typeof startMyUserOnboardingMutationKey
>

/**
 * @description Supplier portal users only. Creates onboarding state for the authenticated user if missing, or touches lastSeen when already in progress. invitedOrganizationId is taken from the user's current organization.
 * @summary Start or resume current user onboarding
 * {@link /v1/user-onboarding/me/start}
 */
export async function startMyUserOnboarding(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    StartMyUserOnboardingMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "POST", url: `/v1/user-onboarding/me/start`, ...requestConfig })
  return res
}

export function startMyUserOnboardingMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const mutationKey = startMyUserOnboardingMutationKey()
  return mutationOptions<
    ResponseConfig<StartMyUserOnboardingMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >({
    mutationKey,
    mutationFn: async () => {
      return startMyUserOnboarding(config)
    },
  })
}

/**
 * @description Supplier portal users only. Creates onboarding state for the authenticated user if missing, or touches lastSeen when already in progress. invitedOrganizationId is taken from the user's current organization.
 * @summary Start or resume current user onboarding
 * {@link /v1/user-onboarding/me/start}
 */
export function useStartMyUserOnboarding<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<StartMyUserOnboardingMutationResponse>,
      ResponseErrorConfig<Error>,
      void,
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? startMyUserOnboardingMutationKey()

  const baseOptions = startMyUserOnboardingMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<StartMyUserOnboardingMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >

  return useMutation<
    ResponseConfig<StartMyUserOnboardingMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<StartMyUserOnboardingMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >
}
